"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.search");
var _BookingTablePane = _interopRequireDefault(require("./BookingTablePane"));
var _BookingConfigPane = _interopRequireDefault(require("./BookingConfigPane"));
var _BookingOrderTable = _interopRequireDefault(require("./BookingOrderTable"));
var _BookingReturnTable = _interopRequireDefault(require("./BookingReturnTable"));
var _BookingReviewTable = _interopRequireDefault(require("./BookingReviewTable"));
var _RefundDetailTab = _interopRequireDefault(require("./RefundDetailTab.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'booking',
  components: {
    RefundDetailTab: _RefundDetailTab.default,
    BookingTablePane: _BookingTablePane.default,
    BookingConfigPane: _BookingConfigPane.default,
    BookingOrderTable: _BookingOrderTable.default,
    BookingReturnTable: _BookingReturnTable.default,
    BookingReviewTable: _BookingReviewTable.default
  },
  data: function data() {
    return {
      activeName: 'table',
      bookingList: [],
      refundOrderId: ''
    };
  },
  created: function created() {},
  methods: {
    handleConfig: function handleConfig(values) {
      this.activeName = 'config';
      this.bookingList = values || [];
    },
    refundDetail: function refundDetail(values) {
      this.activeName = 'refund_detail';
      this.refundOrderId = values || '';
    },
    handleSuccess: function handleSuccess() {
      this.activeName = 'table';
      this.$refs.booking_table_pane.search();
    }
  }
};